import {ID, Resource} from 'simpli-web-sdk'
import DeliveryUfResponseSchema from '@/schema/DeliveryUfResponse.schema'

export default class DeliveryUfResponse extends Resource {

  readonly $name: string = 'DeliveryUfResponse'
  readonly $endpoint: string = '/user/indicador/entrega-por-uf'

  get $id() {
    return this.id
  }
  set $id(val: ID) {
    this.id = val
  }

  get $schema() {
    return DeliveryUfResponseSchema(this)
  }

  id: ID = 0
  nome: string | null = null
  qtdTotal: number | null = null
  qtdSemOcorrencia: number | null  = null
  qtdComOcorrencia: number | null  = null
  qtdDevolvidas: number | null  = null

}
